<template>
  <div>
    <div class="d-flex flex-wrap align-center">
      <v-switch
        v-model="isOn"
        label="SIMPLE"
        hide-details
        inset
        :disabled="isDbManaged"
        class="pa-0 ma-0 pb-4"
        @click="$emit('is-on', isOn)"
      />

      <transition name="fadeLeft">
        <v-row
          v-if="isOn"
          style="animation-duration: 0.3s;"
          class="ms-2 d-inline-flex"
        >
          <v-col style="width: auto; max-width: min-content;">
            <v-select
              v-model="nearestTo"
              :items="nearestToValues"
              item-text="value"
              suffix="分単位"
              :disabled="isDbManaged"
              class="pa-0 ma-0"
              :menu-props="{ auto: true, offsetY: true }"
              style="width: auto; max-width: min-content;"
            />
          </v-col>
          <v-col style="width: auto; max-width: min-content;">
            <v-select
              v-model="method"
              :items="methodValues"
              item-text="text"
              :disabled="isDbManaged"
              class="pa-0 ma-0"
              :menu-props="{ auto: true, offsetY: true }"
              style="width: auto; max-width: min-content; min-width: 92px;"
            />
          </v-col>
        </v-row>
      </transition>
    </div>

    <v-snackbar
      :value="showMsg"
      top
      centered
      timeout="2000"
    >
      {{ isDbManaged ? '店舗設定で管理されています' : 'SIMPLEモードは端末依存の設定です。この設定はこの端末のみに保存されます。' }}
    </v-snackbar>
  </div>
</template>

<script>
import { ref, watch, computed } from '@vue/composition-api'
import { mdiDotsVertical } from '@mdi/js'

export default {
  props: {
    clubRoundingConfig: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const key = 'simpleClockIn'

    // DB設定が有効かどうか
    const isDbManaged = computed(() => !!props.clubRoundingConfig?.timecardRoundingEnabled)

    // DB設定が有効ならDB値、そうでなければlocalStorageから復元
    const stored = JSON.parse(localStorage.getItem(key) || '{}')

    const isOn = ref(
      isDbManaged.value
        ? true
        : (!!stored.nearestTo || !!stored.method),
    )
    const nearestTo = ref(
      isDbManaged.value
        ? props.clubRoundingConfig.timecardRoundingUnit
        : (stored.nearestTo || null),
    )
    const method = ref(
      isDbManaged.value
        ? props.clubRoundingConfig.timecardRoundingMethod
        : (stored.method || null),
    )
    const showMsg = ref(false)

    const nearestToValues = [
      { value: 1 },
      { value: 5 },
      { value: 10 },
      { value: 15 },
      { value: 20 },
      { value: 30 },
    ]
    const methodValues = [
      { text: '四捨五入', value: 'round' },
      { text: '切り上げ', value: 'ceil' },
      { text: '切り捨て', value: 'floor' },
    ]

    // localStorage 更新用ユーティリティ（DB管理時は更新しない）
    const updateStorage = () => {
      if (isDbManaged.value) return

      localStorage.setItem(
        key,
        JSON.stringify({
          nearestTo: nearestTo.value,
          method: method.value,
        }),
      )
    }

    // DB設定が変わったら反映
    watch(() => props.clubRoundingConfig, config => {
      if (config?.timecardRoundingEnabled) {
        isOn.value = true
        nearestTo.value = config.timecardRoundingUnit
        method.value = config.timecardRoundingMethod
      }
    }, { deep: true })

    // isOn の変化に合わせて nearestTo と method の初期値をセット
    watch(isOn, (newVal, oldVal) => {
      if (isDbManaged.value) return

      if (newVal) {
        if (!nearestTo.value) nearestTo.value = 1
        if (!method.value) method.value = 'round'
        showMsg.value = false
      } else {
        nearestTo.value = null
        method.value = null
      }

      if (oldVal !== undefined && !oldVal && newVal) {
        showMsg.value = true
      }

      updateStorage()
      emit('is-on', newVal)
    }, { immediate: true })

    watch(nearestTo, newVal => {
      if (isDbManaged.value) return

      if (!nearestToValues.some(item => item.value === newVal)) {
        isOn.value = false
        nearestTo.value = null
      }
      updateStorage()
    })

    watch(method, newVal => {
      if (isDbManaged.value) return

      if (!methodValues.some(item => item.value === newVal)) {
        isOn.value = false
        method.value = null
      }
      updateStorage()
    })

    // 初期状態を emit
    emit('is-on', isOn.value)

    return {
      isOn,
      nearestTo,
      method,
      showMsg,
      isDbManaged,
      nearestToValues,
      methodValues,
      icons: {
        mdiDotsVertical,
      },
    }
  },
}
</script>
